angular.
module("digiexam.components").
directive("lightboxImage", function lightboxImageDirective(lightbox) {
	"use strict";

	return {
		restrict: "A",

		link: function link($scope, element, attrs) {
			element.on("click", function onClick(event) {
				event.preventDefault();
				var attrNgSrc = attrs.ngSrc;
				var attrSrc = attrs.src;
				var src = attrNgSrc || attrSrc;
				lightbox.show(src);
			});
		},
	};
});
